import React, { useState, useEffect } from 'react';
// Import the MobileOffcanvasMenu component
import MobileOffcanvasMenu from './MobileOffcanvasMenu';
// Import getSubcategories function
import { getSubcategories } from '../functions/Categories';

function MobileHeader() {
  // State to manage offcanvas visibility
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  // Add state for categories
  const [categories, setCategories] = useState({ India: [], International: [], Weekend: [], More: [] });

  useEffect(() => {
    const fetchAll = async () => {
      const india = await getSubcategories("india");
      const international = await getSubcategories("international");
      const weekend = await getSubcategories("weekend");
      const more = await getSubcategories("more");
      setCategories({
        India: india || [],
        International: international || [],
        Weekend: weekend || [],
        More: more || []
      });
    };
    fetchAll();
  }, []);

  // Function to toggle offcanvas visibility
  const handleToggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  // Function to close offcanvas (can be the same as toggle or specific)
  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
  };

  return (
    // Wrap existing nav and the offcanvas menu in a Fragment
    <>
      <nav className="navbar navbar-dark py-2 mobile-nav d-block d-lg-none" style={{ background: 'linear-gradient(to right, #FFA500, #ffd700)' }}>
        <div className="container">
          {/* Logo on the left */}
          <a className="navbar-brand" href="/">
            <img src="/assets/images/syw-logo.png" alt="Swayyourway Logo" height="40" />
          </a>

          {/* Call icon and menu icon on the right */}
          <div className="d-flex align-items-center">
            {/* Call icon */}
            <a href="tel:+919220424206" className="me-3 text-white">
              <i className="fas fa-phone-alt"></i>
            </a>

            {/* Menu hamburger icon */}
            <button
              className="navbar-toggler border-0"
              type="button"
              onClick={handleToggleOffcanvas} // Use onClick handler
              aria-controls="mobileMenu" // Good for accessibility
              aria-expanded={showOffcanvas} // Good for accessibility
            >
              {/* Replace span with Font Awesome icon */}
              <i className="fas fa-bars text-white"></i>
            </button>
          </div>
        </div>
      </nav>
      {/* Render the MobileOffcanvasMenu component with props */}
      <MobileOffcanvasMenu
        show={showOffcanvas}
        handleClose={handleCloseOffcanvas}
        categories={categories}
      />
    </>
  );
}

export default MobileHeader;
